import React, { useEffect, useState } from 'react'
import { Grid, GridItem } from '@chakra-ui/react'
import { GetStatus, Months } from '../../../../Utils'
import MonthBarChart from './MonthBarChart'
import TotalsPieChart from './TotalsPieChart'

const initialDataMonth = Months?.getArrayNamesMonths()?.map((item) => ({
  month: item?.substring(0, 3),
  total: 0
}))

const initialDataPie = [
  { name: '', value: 0 },
  { name: '', value: 0 }
]

const Metrics = ({ data }) => {
  const [dataMonth, setDataMonth] = useState(initialDataMonth)
  const [dataPie, setDataPie] = useState(initialDataPie)

  useEffect(() => {
    if (data?.totalByMonth) {
      const monthformated =
        data?.totalByMonth?.length > 0
          ? data?.totalByMonth?.map((item) => ({
              month: Months?.getNameMonths(item?.monthIndex)?.substring(0, 3),
              total: item?.total
            }))
          : initialDataMonth
      setDataMonth(monthformated)
    }

    const dataPieFormated = [
      {
        name: 'TOTAL',
        value: data?.totalElement || 0,
        color: GetStatus?.getStatusColorBg[data?.state] || '#bdb8b7'
      },
      {
        name: GetStatus?.getStatus[data?.state] || '',
        value: data?.totalByState || 0,
        color: GetStatus?.getStatusColor[data?.state] || '#bdb8b7'
      }
    ]
    setDataPie(dataPieFormated)
  }, [data])

  return (
    <Grid
      templateColumns={{
        lg: 'repeat(2, 70% 30%)',
        md: 'repeat(1, 100%)',
        sm: 'repeat(1, 100%)'
      }}
      h={{
        lg: '400px',
        md: '400px',
        sm: '400px'
      }}
      gap={2}
    >
      <GridItem>
        <MonthBarChart
          data={dataMonth}
          color={GetStatus?.getStatusColor[data?.state] || '#bdb8b7'}
        />
      </GridItem>
      <GridItem>
        <TotalsPieChart
          data={dataPie}
          state={GetStatus?.getStatus[data?.state] || ''}
        />
      </GridItem>
    </Grid>
  )
}

export default Metrics
